import { post, downLoadFile } from '../../xhr/fetch'
import { OPERATION_CENTER_PREFIX } from '../../config'

// 操作营业数据列表
export const GET_REPORT_LOG_LIST = (data) => {
  return post(`${OPERATION_CENTER_PREFIX}/statistics/v1/operation/page`, data)
}

// 导出营业数据营业数据
export const EXPORT_REPORT_LOG_LIST = (data) => {
  return downLoadFile(
    `${OPERATION_CENTER_PREFIX}/statistics/v1/operation/export`,
    data
  )
}
